//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.fragment

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.missingField
import kotlin.String
import kotlin.collections.List

public object SentenceFieldsImpl_ResponseAdapter {
  public object SentenceFields : Adapter<blazern.lexisoup.graphql.model.fragment.SentenceFields> {
    public val RESPONSE_NAMES: List<String> = listOf("text", "langIso3", "source")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): blazern.lexisoup.graphql.model.fragment.SentenceFields {
      var _text: String? = null
      var _langIso3: String? = null
      var _source: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _text = StringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _langIso3 = StringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _source = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return blazern.lexisoup.graphql.model.fragment.SentenceFields(
        text = _text ?: missingField(reader, "text"),
        langIso3 = _langIso3 ?: missingField(reader, "langIso3"),
        source = _source ?: missingField(reader, "source")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: blazern.lexisoup.graphql.model.fragment.SentenceFields,
    ) {
      writer.name("text")
      StringAdapter.toJson(writer, customScalarAdapters, value.text)

      writer.name("langIso3")
      StringAdapter.toJson(writer, customScalarAdapters, value.langIso3)

      writer.name("source")
      StringAdapter.toJson(writer, customScalarAdapters, value.source)
    }
  }
}
